<template>
  <nav>
    <ul class="page-nav-pagination page-nav-pagination-success justify-content-center mb-0" v-if="items.total > items.per_page">
      <li :disabled="items.first_page_url !== null && items.current_page !== 1"   class="page-nav-page-item previous" @click.prevent="firstPage" :class="{'disabled': items.current_page === 1}">
        <a  class="page-nav-page-link px-3" href="">
          <i class="bx bxs-chevrons-left"></i>
        </a>
      </li>
      <li :disabled="items.prev_page_url !== null"   class="page-nav-page-item previous" @click.prevent="prevPage" :class="{'disabled': items.current_page === 1}">
        <a  class="page-nav-page-link px-3" href="">
          <i class="bx bxs-chevron-left"></i>
        </a>
      </li>

      <li   class="page-nav-page-item active" v-show="items.last_page !== 0" aria-current="page">
        <button  class="page-nav-page-link px-3">{{ items.current_page }}</button>
      </li>

      <li :disabled="items.next_page_url !== null"   class="page-nav-page-item next" @click.prevent="nextPage" :class="{'disabled': (items.current_page !== items.last_page && items.last_page !== 0 && items.current_page !== items.last_page) === false}">
        <a  class="page-nav-page-link px-3" href="">
          <i class="bx bxs-chevron-right"></i>
        </a>
      </li>
      <li :disabled="items.last_page_url !== null && items.current_page !== items.last_page && items.last_page !== 0 && items.current_page !== items.last_page"   class="page-nav-page-item next" @click.prevent="lastPage" :class="{'disabled': (items.current_page !== items.last_page && items.last_page !== 0 && items.current_page !== items.last_page) === false}">
        <a  class="page-nav-page-link px-3" href="">
          <i class="bx bxs-chevrons-right"></i>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { api } from "../../services";
import "../../../js/assets/css/Pagination.css"
export default {
  name: "Pagination",
  props: ['items', 'commit', 'page_item', 'page_link'],
  data() {
    return {}
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    fillTheCommit(response_from_api) {
      if (this.commit === 'SET_TEMPLATES_PAGINATION_CLOUD_API') {
        this.fillDataWhenTemplatesIsCommingCloudApi(response_from_api);
      } else if (this.commit === 'SET_ACTIVITIES_DATA') {
        this.$store.commit('SET_ACTIVITIES_DATA', response_from_api.data.data.data)
        this.$store.commit('SET_ACTIVITIES_PAGINATION', response_from_api.data.data)
        this.$store.commit('SET_METRICS_ACTIVITIES_DATA', response_from_api.data.metrics)
      } else if (this.commit === 'SET_CAMPAIGNS_DATA') {
        this.$store.commit('SET_CAMPAIGNS_DATA', response_from_api.data.data.data)
        this.$store.commit('SET_CAMPAIGNS_PAGINATION', response_from_api.data.data)
        this.$store.commit('SET_CAMPAIGNS_METRICS', response_from_api.data.metrics)
      } else if (this.commit === 'SET_USER_OPERATORS') {
        this.$store.commit('SET_OPERATORS', response_from_api.data)
      } else {
        this.$store.commit(this.commit, response_from_api.data);
      }
    },
    fillDataWhenTemplatesIsCommingCloudApi(response_from_api) {
      if (this.commit === 'SET_TEMPLATES_PAGINATION_CLOUD_API') {
        this.$store.commit('SET_TEMPLATES_PAGINATION_CLOUD_API', response_from_api.data.data)
        this.$store.commit('SET_TEMPLATES', response_from_api.data.data.data)
      }
    },
    firstPage: function () {
      if(this.items.current_page === 1){
        return;
      }
      // this.$store.dispatch('startLoading');
      api.get(this.items.first_page_url).then(response => {
        this.fillTheCommit(response);

      }).then(() => {
        // this.$store.dispatch('stopLoading')
      }).catch(error => {
      }).finally(() => {
      });
    },
    nextPage: function () {
      if(this.items.next_page_url === null){
        return;
      }
      // this.$store.dispatch('startLoading');
      api.get(this.items.next_page_url).then(response => {
        this.fillTheCommit(response);
      }).catch(error => {
      }).finally(() => {
      });
    },
    prevPage: function () {
      if(this.items.current_page === 1){
        return;
      }
      // this.$store.dispatch('startLoading');
      api.get(this.items.prev_page_url).then(response => {
        this.fillTheCommit(response);
      }).then(() => {
        // this.$store.dispatch('stopLoading')
      }).catch(error => {
      }).finally(() => {
      });
    },
    lastPage: function () {
      if(this.items.next_page_url === null){
        return;
      }
      // this.$store.dispatch('startLoading');
      api.get(this.items.last_page_url).then(response => {
        this.fillTheCommit(response);
      }).then(() => {
        // this.$store.dispatch('stopLoading')
      }).catch(error => {
      }).finally(() => {
      });
    }
  }
}
</script>





<!-- 

CODIGO ANTIGO FUNCIONAL, CASO DE ERRO NO ATUAL!
<template>
  <nav>
    <ul class="pagination pagination-success justify-content-center mb-0" v-if="items.total > items.per_page">
      <li :disabled="items.first_page_url !== null && items.current_page !== 1" :style="page_item"  class="page-item previous" @click.prevent="firstPage" :class="{'disabled': items.current_page === 1}">
        <a :style="page_link" class="page-link px-3" href="">
          <i class="bx bxs-chevrons-left"></i>
        </a>
      </li>
      <li :disabled="items.prev_page_url !== null" :style="page_item" class="page-item previous" @click.prevent="prevPage" :class="{'disabled': items.current_page === 1}">
        <a :style="page_link" class="page-link px-3" href="">
          <i class="bx bxs-chevron-left"></i>
        </a>
      </li>

      <li :style="page_item" class="page-item active" v-show="items.last_page !== 0" aria-current="page">
        <button :style="page_link" class="page-link px-3">{{ items.current_page }}</button>
      </li>

      <li :disabled="items.next_page_url !== null" :style="page_item" class="page-item next" @click.prevent="nextPage" :class="{'disabled': (items.current_page !== items.last_page && items.last_page !== 0 && items.current_page !== items.last_page) === false}">
        <a :style="page_link" class="page-link px-3" href="">
          <i class="bx bxs-chevron-right"></i>
        </a>
      </li>
      <li :disabled="items.last_page_url !== null && items.current_page !== items.last_page && items.last_page !== 0 && items.current_page !== items.last_page" :style="page_item" class="page-item next" @click.prevent="lastPage" :class="{'disabled': (items.current_page !== items.last_page && items.last_page !== 0 && items.current_page !== items.last_page) === false}">
        <a :style="page_link" class="page-link px-3" href="">
          <i class="bx bxs-chevrons-right"></i>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { api } from "../../services";
export default {
  name: "Pagination",
  props: ['items', 'commit', 'page_item', 'page_link'],
  data() {
    return {}
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    fillTheCommit(response_from_api) {
      if (this.commit === 'SET_TEMPLATES_PAGINATION_CLOUD_API') {
        this.fillDataWhenTemplatesIsCommingCloudApi(response_from_api);
      } else if (this.commit === 'SET_ACTIVITIES_DATA') {
        this.$store.commit('SET_ACTIVITIES_DATA', response_from_api.data.data.data)
        this.$store.commit('SET_ACTIVITIES_PAGINATION', response_from_api.data.data)
        this.$store.commit('SET_METRICS_ACTIVITIES_DATA', response_from_api.data.metrics)
      } else if (this.commit === 'SET_CAMPAIGNS_DATA') {
        this.$store.commit('SET_CAMPAIGNS_DATA', response_from_api.data.data.data)
        this.$store.commit('SET_CAMPAIGNS_PAGINATION', response_from_api.data.data)
        this.$store.commit('SET_CAMPAIGNS_METRICS', response_from_api.data.metrics)
      } else {
        this.$store.commit(this.commit, response_from_api.data);
      }
    },
    fillDataWhenTemplatesIsCommingCloudApi(response_from_api) {
      if (this.commit === 'SET_TEMPLATES_PAGINATION_CLOUD_API') {
        this.$store.commit('SET_TEMPLATES_PAGINATION_CLOUD_API', response_from_api.data.data)
        this.$store.commit('SET_TEMPLATES', response_from_api.data.data.data)
      }
    },
    firstPage: function () {
      if(this.items.current_page === 1){
        return;
      }
      // this.$store.dispatch('startLoading');
      api.get(this.items.first_page_url).then(response => {
        this.fillTheCommit(response);

      }).then(() => {
        // this.$store.dispatch('stopLoading')
      }).catch(error => {
      }).finally(() => {
      });
    },
    nextPage: function () {
      if(this.items.next_page_url === null){
        return;
      }
      // this.$store.dispatch('startLoading');
      api.get(this.items.next_page_url).then(response => {
        this.fillTheCommit(response);
      }).catch(error => {
      }).finally(() => {
      });
    },
    prevPage: function () {
      if(this.items.current_page === 1){
        return;
      }
      // this.$store.dispatch('startLoading');
      api.get(this.items.prev_page_url).then(response => {
        this.fillTheCommit(response);
      }).then(() => {
        // this.$store.dispatch('stopLoading')
      }).catch(error => {
      }).finally(() => {
      });
    },
    lastPage: function () {
      if(this.items.next_page_url === null){
        return;
      }
      // this.$store.dispatch('startLoading');
      api.get(this.items.last_page_url).then(response => {
        this.fillTheCommit(response);
      }).then(() => {
        // this.$store.dispatch('stopLoading')
      }).catch(error => {
      }).finally(() => {
      });
    }
  }
}
</script>

<style scoped>
.page-item.disabled .page-link {
  color: #d2d2d4;
  pointer-events: none;
  cursor: auto;
  background-color: #f4f4f4;
  border-color: #f4f4f4;
}
</style> -->